define('views/reseller-map-locator',['jquery', 'utils/View', 'connections/locator-connection'], function(
  $,
  View,
  LocatorConnection
) {
  var ResellerMapLocator = (function() {
    function ResellerMapLocator() {}

            ResellerMapLocator.prototype.init = function() {
				var self = this;
                this.googleMap = $("#map");
                this.markers = [];
                this.canvas = this.googleMap[0];
				var googleUrl = this.googleMap.data("url");
				this.country = this.googleMap.data("country");
				LocatorConnection.loadAddressViews().then(function(data){
					$('#retailers-container').html(data);
                });
                if (googleUrl)
                {
                    $.getScript(googleUrl);
                    $('#retailers-container').on('click', '.retail-toggle', self.toggleRetailer.bind(self));
                }
            };

    ResellerMapLocator.prototype.googleCallback = function() {
      var self = this;

      self.map = new google.maps.Map(self.canvas, {
        zoom: 5,
        mapTypeControl: false,
        streetViewControl: false,
        scrollwheel: false
      });

      addStyles(self.map);
      setCountry(self.map, self.country);

      LocatorConnection.loadAddresses().then(function(data) {
        $.each(data, function(i, country) {
          if (country.Name != '') {
            $.each(country.CityList, function(i, city) {
              if (city.Name != '') {
                $.each(city.StoreList, function(i, store) {
                  var location = { lat: store.Latitude, lng: store.Longitude };
                  addMarker(self.map, self.markers, location, store);
                });
              }
            });
          }
        });

        initSearch(self.map, self.markers, self.country);
      });

      google.maps.event.addListener(self.map, 'zoom_changed', function() {
        hideShowRetailersZoom(self.map, self.markers);
      });

      google.maps.event.addListener(self.map, 'dragend', function() {
        hideShowRetailersZoom(self.map, self.markers);
      });

      google.maps.event.addListener(self.map, 'idle', function() {
        zoomLevel = self.map.getZoom();

        if (zoomLevel > 5) {
          $('#retailers-container').show();
        }
      });
    };

    ResellerMapLocator.prototype.toggleRetailer = function(event) {
      var currentLocator = $(event.currentTarget).parent();
      var currentTarget = currentLocator.find('.retail-content');
      var currentTargetIsVisible = currentTarget.is(':visible');

      $('.retail-content').hide();
      currentTarget.toggle(!currentTargetIsVisible);
      slideIntoView(currentTarget);
    };

    return ResellerMapLocator;
  })();

  function setCountry(map, country) {
    var geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: country }, function(results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        map.setCenter(results[0].geometry.location);
      }
    });
  }

  function sortRetailers(visiblePins) {
    $.each(visiblePins, function(i, item) {
      var targetElement = $(item.marker.targetElement);
      targetElement.parent().append(targetElement);
    });
  }

  function postalAreaOwnerFirst(owner) {
    var $owner = $(owner.targetElement);
    $owner.parent().prepend($owner);
  }

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }

    return function(a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;

      return result * sortOrder;
    };
  }

  function isInArray(array, searchFor) {
    return array.indexOf(searchFor) >= 0;
  }

  function distanceBetweenPinsKm(lat1, long1, lat2, long2) {
    var _eQuatorialEarthRadius = 6378.137;
    var _d2r = Math.PI / 180.0;

    var dlong = (long2 - long1) * _d2r;
    var dlat = (lat2 - lat1) * _d2r;

    var a =
      Math.pow(Math.sin(dlat / 2.0), 2.0) +
      Math.cos(lat1 * _d2r) *
        Math.cos(lat2 * _d2r) *
        Math.pow(Math.sin(dlong / 2.0), 2.0);
    var c = 2.0 * Math.atan2(Math.sqrt(a), Math.sqrt(1.0 - a));
    var d = _eQuatorialEarthRadius * c;

    return d;
  }

  function initSearch(map, markers, country) {
    var input = document.getElementById('locator-input');

    var options = {
      types: ['(regions)'],
      componentRestrictions: { country: country }
    };

    var autocompleteBox = new google.maps.places.Autocomplete(input, options);
    autocompleteBox.bindTo('bounds', map);

    $('.action ').click(function() {
      var $firstResult = $('.pac-item:first').children();
      var placeName = $firstResult[1].textContent;
      var placeAddress = $firstResult[2].textContent;

      $(autocompleteBox).val(placeName + ', ' + placeAddress);

      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: placeName }, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          completeSearchNoInput(results);
        }
      });

      return false;
    });

    autocompleteBox.addListener('place_changed', function() {
      var place = autocompleteBox.getPlace();
      var $firstResult, placeName, placeAddress, geocoder;

      if (place === undefined) {
        $firstResult = $('.pac-item:first').children();
        placeName = $firstResult[1].textContent;
        placeAddress = $firstResult[2].textContent;

        $(autocompleteBox).val(placeName + ', ' + placeAddress);

        geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: placeName }, function(results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            completeSearchNoInput(results);
          }
        });
      }

      if (place !== undefined && place.geometry === undefined) {
        $firstResult = $('.pac-item:first').children();
        placeName = $firstResult[1].textContent;
        placeAddress = $firstResult[2].textContent;

        $(autocompleteBox).val(placeName + ', ' + placeAddress);

        geocoder = new google.maps.Geocoder();
        var searchvalue;

        if (placeAddress == '') {
          searchvalue = placeName;
        } else {
          searchvalue = placeAddress;
        }

        geocoder.geocode(
          {
            address: searchvalue,
            componentRestrictions: { country: 'SE' }
          },
          function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              completeSearchNoInput(results);
            }
          }
        );
      }

      if (place !== undefined && place.geometry !== undefined) {
        bounds = new google.maps.LatLngBounds();
        bounds.extend(place.geometry.location);

        map.setCenter(bounds.getCenter());
        map.setZoom(10);

        completeSearch(place, bounds, markers, map);
      }
    });
  }

  function completeSearch(place, bounds, markers, map) {
    var searchLat = place.geometry.location.lat();
    var searchLng = place.geometry.location.lng();
    var postalArea;

    postalArea = checkForPostalArea(place.address_components);

    if (postalArea !== undefined) {
      setViewportAreaByPlace(
        postalArea,
        bounds,
        searchLat,
        searchLng,
        markers,
        map
      );
    } else {
      var geocoder = new google.maps.Geocoder();

      geocoder.geocode(
        { location: { lat: searchLat, lng: searchLng } },
        function(results, status) {
          if (status === 'OK') {
            postalArea = checkForPostalArea(results[0].address_components);
            setViewportAreaByPlace(
              postalArea,
              bounds,
              searchLat,
              searchLng,
              markers,
              map
            );
          }
        }
      );
    }
  }

  function checkForPostalArea(addressComponents) {
    for (i = 0; i < addressComponents.length; i++) {
      var address = addressComponents[i];

      if (address.types[0] === 'postal_code') {
        return getFirst3(address.long_name);
      }
    }
  }

  function getFirst3(postalCode) {
    return postalCode.split(' ')[0];
  }

  function setViewportAreaByPlace(
    postalArea,
    bounds,
    searchLat,
    searchLng,
    markers,
    map
  ) {
    var inViewport = false;
    var inViewportOwner = false;
    var visiblePins = [];
    var postalAreaOwner;

    for (var i = 0; i < markers.length; i++) {
      var marker = markers[i];
      var targetLat = marker.getPosition().lat();
      var targetLng = marker.getPosition().lng();
      var distance = distanceBetweenPinsKm(
        searchLat,
        searchLng,
        targetLat,
        targetLng
      );

      visiblePins.push({
        marker: marker,
        distance: distance
      });

      var postalCodes = marker.storeInformation.PostalAreas;
      if (postalCodes !== undefined && isInArray(postalCodes, postalArea)) {
        postalAreaOwner = marker;
      }

      if (
        postalAreaOwner !== undefined &&
        map.getBounds().contains(postalAreaOwner.getPosition())
      ) {
        inViewportOwner = true;
      }

      if (map.getBounds().contains(marker.getPosition())) {
        inViewport = true;
      }
    }

    visiblePins.sort(dynamicSort('distance'));
    sortRetailers(visiblePins);

    if (postalAreaOwner !== undefined) {
      postalAreaOwnerFirst(postalAreaOwner);
    }

    if (!inViewport || (!inViewportOwner && postalAreaOwner !== undefined)) {
      if (postalAreaOwner !== undefined) {
        bounds.extend(postalAreaOwner.position);
        map.fitBounds(bounds);
      } else {
        var closestMarker = visiblePins[0].marker;
        bounds.extend(closestMarker.position);
        map.fitBounds(bounds);
      }
    }
  }

  function addStyles(map) {
    var styles = [
      {
        featureType: 'road',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ color: '#cccccc' }]
      },
      {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [{ color: '#ffffff' }]
      },
      {
        featureType: 'landscape',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#00bfff' }]
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ visibility: 'off' }]
      },
      {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [{ color: '#ededed' }]
      },
      {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [{ visibility: 'off' }]
      },
      {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
      }
    ];

    map.setOptions({ styles: styles });
  }

  function addMarker(locatorMap, markers, location, store) {
    var map = locatorMap;
    var marker = new google.maps.Marker({
      position: location,
      map: map,
      targetElement: setTargetElementName(store.ID),
      markerID: store.ID,
      animation: google.maps.Animation.DROP,
      storeInformation: store
    });

    markers.push(marker);

    var infowindow = new google.maps.InfoWindow({
      content: marker.storeInformation.Name
    });

    google.maps.event.addListener(marker, 'mouseover', function() {
      if (map.getZoom() > 5) {
        infowindow.open(map, this);
      }
    });

    google.maps.event.addListener(marker, 'mouseout', function() {
      if (map.getZoom() > 5) {
        infowindow.close();
      }
    });

    google.maps.event.addListener(marker, 'click', function() {
      $('.retail-content').hide();
      if (map.zoom <= 5) {
        map.setZoom(map.zoom + 1);
        map.setCenter(marker.getPosition());

        return;
      }

      var targetElm = $(marker.targetElement);
      slideIntoView(targetElm);
    });
  }

  function slideIntoView(targetElm) {
    $('html, body').animate({
      scrollTop: targetElm.offset().top - 100
    });

    targetElm
      .addClass('active')
      .find('.retail-content')
      .slideDown();
  }

  function hideShowRetailersZoom(map, markers) {
    if (map.getZoom() <= 5) {
      $('#retailers-container').hide();
    } else {
      var bounds = map.getBounds();
      $('.retail-item').hide();
      var items = markers.filter(function(marker) {
        return bounds.contains(marker.getPosition());
      });
      items.forEach(function(marker) {
        $(marker.targetElement).show();
      });
    }
  }

  function setTargetElementName(index) {
    return '#retail-result-' + index;
  }

  return View('ResellerMapLocator', function(elem) {
    var resellerMapLocator = new ResellerMapLocator();
    window.googleMapInit = resellerMapLocator.googleCallback.bind(
      resellerMapLocator
    );
    resellerMapLocator.init();
  });
});

